import { render, staticRenderFns } from "./AddTestPopup.vue?vue&type=template&id=d89ac198&scoped=true"
import script from "./AddTestPopup.vue?vue&type=script&lang=js"
export * from "./AddTestPopup.vue?vue&type=script&lang=js"
import style0 from "./AddTestPopup.vue?vue&type=style&index=0&id=d89ac198&prod&lang=scss&scoped=true"
import style1 from "./AddTestPopup.vue?vue&type=style&index=1&id=d89ac198&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d89ac198",
  null
  
)

export default component.exports